<template>
  <div>
    <Header />
    <v-main>
      <v-container>
        <v-row>
          <v-col cols="10" offset="1">
            <v-card class="pa-4" width="100%" text>
              <CardTitle class="justify-center display-3" :title="translate.title" />

              <!-- Introduction  -->
              <CardText :text="translate.text1" />
              <CardText :text="translate.text2" />

              <!-- Collecte des données -->
              <CardTitle class="display-1" :title="translate.dataCollection.title" />
              <CardText :text="translate.dataCollection.text1" />
              <CardList :list="translate.dataCollection.list" />
              <CardText :text="translate.dataCollection.text2" />

              <!-- Le traitement de vos données personnelles -->
              <CardTitle class="display-1" :title="translate.personalData.title" />
              <CardTitle :title="translate.personalData.subtitle" class="title" />
              <CardText :text="translate.personalData.text1" />
              <CardText :text="translate.personalData.text2" />
              <CardList :list="translate.personalData.list1" />
              <CardText :text="translate.personalData.text3" />
              <CardList :list="translate.personalData.list2" />

              <!-- Traitements basés sur l’intérêt légitime -->
              <CardTitle class="display-1" :title="translate.legitimateInterest.title" />
              <CardText :text="translate.legitimateInterest.text" />
              <CardList :list="translate.legitimateInterest.list" />

              <!-- Traitements basés sur votre consentement -->
              <CardTitle class="display-1" :title="translate.consent.title" />
              <CardText :text="translate.consent.text1" />
              <CardList :list="translate.consent.list" />
              <CardText :text="translate.consent.text2" />
              <CardText :text="translate.consent.text3" />
              <CardText :text="translate.consent.text4" />

              <!-- Destinataires de vos données personnelles -->
              <CardTitle class="display-1" :title="translate.recipentPersonalData.title" />
              <CardText :text="translate.recipentPersonalData.text" />
              <CardList :list="translate.recipentPersonalData.list" />

              <!-- Conditions de traitement et de stockage de vos données personnelles -->
              <CardTitle class="display-1" :title="translate.storagePersonalData.title" />
              <CardText :text="translate.storagePersonalData.text1" />
              <CardText :text="translate.storagePersonalData.text2" />

              <!-- Liens vers d’autres sites Web non contrôlés par Stampyt -->
              <CardTitle class="display-1" :title="translate.linkWebSite.title" />
              <CardText :text="translate.linkWebSite.text1" />
              <CardText :text="translate.linkWebSite.text2" />

              <!-- Transfert de vos données personnelles -->
              <CardTitle class="display-1" :title="translate.transferPersonalData.title" />
              <CardText :text="translate.transferPersonalData.text1" />
              <CardText :text="translate.transferPersonalData.text2" />

              <!-- Sécurité de vos Données personnelles -->
              <CardTitle class="display-1" :title="translate.securityPersonalData.title" />
              <CardText :text="translate.securityPersonalData.text1" />
              <CardText :text="translate.securityPersonalData.text2" />
              <CardText :text="translate.securityPersonalData.text3" />

              <!-- Droit d’accès et de rectification des données personnelles -->
              <CardTitle class="display-1" :title="translate.accessPersonalData.title" />
              <CardText :text="translate.accessPersonalData.text1" />
              <CardText :text="translate.accessPersonalData.text2" />
              <CardText :text="translate.accessPersonalData.text3" />
              <CardText :text="translate.accessPersonalData.text4" />

              <!-- Résolution des conflits -->
              <CardTitle class="display-1" :title="translate.resolveConflicts.title" />
              <CardText :text="translate.resolveConflicts.text" />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <Footer />
  </div>
</template>

<script>
import CardTitle from '@/components/CardTitle'
import CardText from '@/components/CardText'
import CardList from '@/components/CardList'

export default {
  name: 'PrivacyPolicy',
  components: {
    CardTitle,
    CardText,
    CardList
  },
  computed: {
    translate() {
      return this.$t('privacyPolicy')
    }
  }
}
</script>
